export const debtTypeMap = [
  {
    name: 'Credit Card',
    value: 'CREDIT_CARD'
  },
  {
    name: 'Installment Loan',
    value: 'INSTALLMENT_LOAN'
  },
  {
    name: 'PayDay Loan',
    value: 'PAYDAY_LOAN'
  },
  {
    name: 'Medical Debt',
    value: 'MEDICAL DEBT'
  },
  {
    name: 'Student Loan',
    value: 'STUDENT_LOAN'
  },
  {
    name: 'Mortgage Loan',
    value: 'MORTGAGE_LOAN'
  },
  {
    name: 'Auto Loan',
    value: 'AUTO_LOAN'
  },
  {
    name: 'Personal Loan',
    value: 'PERSONAL_LOAN'
  },
  {
    name: 'Back taxes',
    value: 'BACK_TAXES'
  }
];
